export const formatBytes = (bytes: number): number => {
  return bytes / (1024 * 1024);
};
